import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import CancelIcon from "@material-ui/icons/Cancel";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import _without from "lodash-es/without";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((styleProp) => ({
  formControl: {
    width: "300px",
    border: "1px solid gray",
  },
  list: {
    backgroundColor: "green",
  },
  input: {
    backgroundColor: "blue",
    padding: "4px",
  },

  select: {
    backgroundColor: "red",
  },
  outlined: {
    padding: 0,
    paddingRight: 35,
    "&$focused": {
      border: 0,
    },
  },
  iconOpen: {},
  root: {
    width: "271px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: (styleProp) => styleProp.border || "1px solid #C4C4C4",
    borderRadius: (styleProp) => styleProp.borderRadius || 2,
    opacity: 1,
    textAlign: (styleProp) => styleProp.textAlign || "start",
    minHeight: (styleProp) => styleProp.maxHeight || 26,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
      },
      "&:hover fieldset": {
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #C4C4C4",
        borderRadius: "2px",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid #C4C4C4",
      },
    },
    "& .MuiPaper-root": {
      top: "200px",
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chipRoot: {
    margin: 4,
  },
  chip: {
    margin: 4,
    height: "20px",
    textAlign: "left",
    font: "normal normal normal 12px/20px Open Sans",
    letterSpacing: 0,
    color: "#000000",
    opacity: 1,
    borderRadius: 2,
    "& label": {
      paddingLeft: -8,
      paddingRight: -8,
    },
  },
  chipLabel: {
    paddingLeft: 4,
    paddingRight: 4,
  },
  chipSizeSmall: {
    margin: 4,
  },
  listSubheaderRoot: {
    textAlign: "left",
    font: "normal normal 600 11px/20px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  focused: {
    backgroundColor: "red",
    border: 0,
  },
  notchedOutline: {
    border: 0,
  },
}));

const CustomCheckbox = withStyles({
  root: {
    color: "#0072C6",
    "&$checked": {
      color: "#0072C6",
    },
  },
  icon: {
    width: 12,
    height: 12,
    color: "#0072C6",
    borderRadius: "2px",
    opacity: 1,
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CustomListItemText = withStyles({
  primary: {
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    font: "normal normal normal 12px/20px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  gutters: {
    paddingLeft: "27px",
  },
})((props) => <ListItemText {...props} />);

const CustomMenuItem = withStyles({
  root: {
    paddingTop: "0px",
    paddingBottom: "0px",
  },
  gutters: {
    paddingLeft: "17px",
  },
  selected: {
    backgroundColor: "rgba(0, 0, 0, 0.00) !important",
  },
})((props) => <MenuItem {...props} />);

export default function MultiSelectCustom(props) {
  const { t } = useTranslation();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const categories = {
    Control: [
      { Title: "Textbox", value: "Textbox" },
      { Title: "Radio", value: "Radio" },
      { Title: "Checkbox", value: "Checkbox" },
      { Title: "Toggle", value: "Toggle" },
    ],
  };

  const classes = useStyles({
    minWidth: props.minWidth,
    maxWidth: props.maxWidth,
    border: props.border,
  });

  var dynamicOptions = [];
  Object.keys(categories).forEach(function categoryFunc(categoryName, index) {
    categories[categoryName].forEach((optionName, optIndex) => {
      dynamicOptions.push(
        <CustomMenuItem
          key={optionName.value}
          value={optionName.value}
          dir={translationStyles1 ? "rtl" : "ltr"}
        >
          <CustomCheckbox
            checked={props.selectedOptions.includes(optionName.value)}
            color="blue"
          />
          <CustomListItemText primary={t(optionName.value)} />
        </CustomMenuItem>
      );
    });
  });

  const handleChange = (event) => {
    props.setSelectedCustomControl("");
    if (event.target.value !== undefined && event.target.value !== null) {
      props.setSelectedOptions(
        event.target.value.filter(function (element) {
          return element !== undefined;
        })
      );
    }
  };

  const handleDelete = (e, value) => {
    e.preventDefault();
    props.setSelectedOptions((current) => _without(current, value));
  };

  useEffect(() => {
    if (props.onChangeHandler) props.onChangeHandler(props.selectedOptions);
    return () => {};
  }, [props.selectedOptions]);

  return (
    <div>
      <div className={classes.redBackground}>
        <FormControl className={classes.formControl} variant="outlined">
          <Select
            labelId={props.id}
            id={props.id}
            multiple
            value={props.selectedOptions}
            onChange={handleChange}
            onOpen={() => console.log()}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value) => (
                  <Chip
                    size="small"
                    key={value}
                    className={classes.chip}
                    label={t(value)}
                    clickable
                    deleteIcon={
                      props.deleteIcon ? (
                        <props.deleteIcon
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      ) : (
                        <CancelIcon
                          style={
                            translationStyles1
                              ? { marginRight: "-4px", marginLeft: "4px" }
                              : null
                          }
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      )
                    }
                    onDelete={(e) => handleDelete(e, value)}
                    onClick={() => console.log()}
                  />
                ))}
              </div>
            )}
            classes={{
              root: classes.root,
              outlined: classes.outlined,
              focused: classes.focused,
              iconOpen: classes.iconOpen,
              input: classes.input,
              list: classes.list,
              padding: classes.padding,
              sizeSmall: classes.sizeSmall,
              notchedOutline: classes.notchedOutline,
            }}
          >
            {dynamicOptions}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}
